<!--
 * @Author: 窦云飞 df1987131@yeah.net
 * @Date: 2024-05-24 15:34:25
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @LastEditTime: 2025-08-26 15:23:30
 * @FilePath: /epec-purchase-shopping-mall/Users/douyunfei/Documents/epec-order-web/components/cart/e-tooltip-over.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="text-tooltip">
    <eui-tooltip
      class="item"
      :content="content"
      :placement="placement"
      :disabled="isShowTooltip"
    >
      <p
        :class="line === 1 ? 'over-flow-1' : 'over-flow-2'"
        :style="{
          width: tooltipStyle.width,
          color: tooltipStyle.color,
          fontSize: tooltipStyle.fontsize,
          cursor: tooltipStyle.cursor,
        }"
        @mouseover="onMouseOver(refName)"
      >
        <span :ref="refName">{{ content || '-' }}</span>
      </p>
    </eui-tooltip>
  </div>
</template>

<script>
export default {
  name: 'TextTooltip',
  props: {
    // 显示的文字内容
    content: {
      type: String,
      default: () => {
        return '';
      },
    },
    // 位置
    placement: {
      type: String,
      default: () => {
        return 'top';
      },
    },
    // 外层框的样式，在传入的这个类名中设置文字显示的宽度
    className: {
      type: String,
      default: () => {
        return '';
      },
    },
    // 显示文字样式
    tooltipStyle: {
      type: Object,
      default: () => {
        return { width: '210px', color: '#333', fontsize: '14px', cursor: '' };
      },
    },
    line: {
      type: Number,
      default: () => {
        return 1;
      },
    },
    // 为页面文字标识（如在同一页面中调用多次组件，此参数不可重复）
    refName: {
      type: String,
      default: () => {
        return '';
      },
    },
  },
  data() {
    return {
      isShowTooltip: true,
    };
  },
  methods: {
    onMouseOver(str) {
      const parentWidth =
        this.line === 1
          ? this.$refs[str].parentNode.offsetWidth
          : this.$refs[str].parentNode.offsetHeight;
      const contentWidth =
        this.line === 1
          ? this.$refs[str].offsetWidth
          : this.$refs[str].offsetHeight;

      // 若子集比中间层更宽 开启tooltip功能
      if (contentWidth > parentWidth) {
        this.isShowTooltip = false;
      } else {
        // 否则 关掉tooltip功能
        this.isShowTooltip = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.text-tooltip {
  font-size: 14px;
  color: #333;
  word-break: break-all;
}
.over-flow-1 {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 210px;
}

.over-flow-2 {
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  overflow: hidden;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  width: 210px;
}
.wid190 {
  width: 100%;
}
p {
  margin: 0;
}
</style>
